import React from "react";
import { registerExtension, EXTENSION_SORT_ORDER } from "@core/components/PipelineComponents/ExtensionProvider";
import { TooltipWrapper } from "@core/components/TooltipWrapper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/pro-light-svg-icons";
import { Switch } from "@core/components/ui/switch";
import { Label } from "@core/components/ui/label";

const CartsComponent = () => {
  // Local state for toggles (not connected to settings yet)
  const [favoritesEnabled, setFavoritesEnabled] = React.useState<boolean>(true);
  const [shoppingListEnabled, setShoppingListEnabled] = React.useState<boolean>(true);
  const [inStockAlertsEnabled, setInStockAlertsEnabled] = React.useState<boolean>(true);

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold">Carts</h3>
      <p className="text-sm text-muted-foreground italic">
        This functionality needs clarification before implementing
      </p>
      <div className="space-y-4">
        {/* Favorites List Toggle */}
        <div className="flex items-center space-x-2">
          <Switch
            id="favoritesList"
            checked={favoritesEnabled}
            onCheckedChange={setFavoritesEnabled}
          />
          <div className="flex items-center gap-2">
            <Label htmlFor="favoritesList" className="cursor-pointer">
              Favorites List
            </Label>
            <TooltipWrapper
              tooltipContent="Allow users to save products to a single Favorites list viewable on the user dashboard"
            >
              <FontAwesomeIcon
                icon={faQuestionCircle}
                className="text-muted-foreground cursor-help"
              />
            </TooltipWrapper>
          </div>
        </div>

        {/* Shopping List Toggle */}
        <div className="flex items-center space-x-2">
          <Switch
            id="shoppingList"
            checked={shoppingListEnabled}
            onCheckedChange={setShoppingListEnabled}
          />
          <div className="flex items-center gap-2">
            <Label htmlFor="shoppingList" className="cursor-pointer">
              Shopping List
            </Label>
            <TooltipWrapper
              tooltipContent="Allow users to custom named lists they can save products to and view on the user dashboard"
            >
              <FontAwesomeIcon
                icon={faQuestionCircle}
                className="text-muted-foreground cursor-help"
              />
            </TooltipWrapper>
          </div>
        </div>

        {/* In Stock Alerts Toggle */}
        <div className="flex items-center space-x-2">
          <Switch
            id="inStockAlerts"
            checked={inStockAlertsEnabled}
            onCheckedChange={setInStockAlertsEnabled}
          />
          <div className="flex items-center gap-2">
            <Label htmlFor="inStockAlerts" className="cursor-pointer">
              In Stock Alerts
            </Label>
            <TooltipWrapper
              tooltipContent="Allow users to receive email notifications when products come back in stock"
            >
              <FontAwesomeIcon
                icon={faQuestionCircle}
                className="text-muted-foreground cursor-help"
              />
            </TooltipWrapper>
          </div>
        </div>
      </div>
    </div>
  );
};

registerExtension(
  "admin.system.sitesetup.siteconfiguration",
  CartsComponent,
  "Carts",
  false,
  EXTENSION_SORT_ORDER.HIGH + 125  // Display after Payments (HIGH + 100)
);
